import CustomSelect from './custom-select';

const initCustomSelect = () => {
  const customSelect = new CustomSelect();
  customSelect.init();
};

export {initCustomSelect};
